import { MessagingBlock } from '@strata/react-messaging-block';
import { useEffect } from 'react';

export const ContingentTherapyRow = () => {
    // Needed to set the colspan of the contingent therapy row
    useEffect(() => {
        document
            .getElementsByClassName('griddle-row--contingent-therapy')?.[0]
            ?.children?.[0]?.setAttribute('colspan', '4');
    }, []);

    return (
        <MessagingBlock
            size={MessagingBlock.Sizes.SMALL}
            primaryText="No authorization required at this time."
            secondaryText="This product falls under a contingent therapy program."
        />
    );
};
